var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ac-container",attrs:{"id":"ac-container"}},_vm._l((_vm.utpItems),function(utpItem){return _c('UtpItem',{key:utpItem.id,attrs:{"utpItem":utpItem,"choose-safe":_vm.chooseSafe,"choose-anon":_vm.chooseAnon,"choose-alerts":_vm.chooseAlerts,"choose-web":_vm.chooseWeb}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }